module.exports = __webpack_public_path__ + "static/media/nc5.7e6506fc.png";